export const checkLink = (link) => {
	return link !== '' && link !== '#';
};
